import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsAraucana = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.valor_cuota)}, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.valor_cuota); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cedente</th>
                    <th className='center'>Documento</th>
                    <th className='center'>Cuota Mora</th>
                    <th className='center'>Primera Mora</th>
                    <th className='center'>Días Mora</th>
                    <th className='right'>Saldo Mora</th>
                    <th className='right'>Saldo Adecuadado</th>
                    <th className='right'>Monto Seguro</th>
                    <th className='right'>Valor Cuota</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.valor_cuota} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    LA ARAUCANA 
                                </label>
                            </td>
                            <td className="center">{doc.num_documento}</td>
                            <td className="center">{doc.cuota_mora}</td>
                            <td className="center">{doc.fecha_primera_mora}</td>
                            <td className="center">{doc.dias_mora}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_mora)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_adecuado)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.monto_seguro)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.valor_cuota)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsAraucana;